import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import CoreuiVue from '@coreui/vue'
import VCalendar from 'v-calendar'
import { iconsSet as icons } from './assets/icons/icons.js'
import VueAnalytics from 'vue-analytics'
import i18n from './plugins/i18n'
import regeneratorRuntime from 'regenerator-runtime'
import VueHtml2Canvas from 'vue-html2canvas'
import Modal from './containers/Modal'
import cssPrint from '../src/assets/styles/print.css'
import VueHtmlToPaper from 'vue-html-to-paper'
import '@/assets/scss/style.scss'
import AccessData from './containers/AccessData'
import AccessGrab from './containers/AccessGrab'
import LoadingPage from './containers/LoadingPage'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebase from 'firebase/app'
import './firebaseInit'
import SelectShop from '../src/containers/SelectShop'
import ShowDate from '../src/containers/ShowDate'
import VueBarcode from 'vue-barcode'
import VueDatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
// import 'v-calendar/style.css';
// import VMdDateRangePicker from 'v-md-date-range-picker'
// import 'v-md-date-range-picker/dist/v-md-date-range-picker.css';
// import VueDatePicker from '@mathieustan/vue-datepicker';
// import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

import VueContentPlaceholders from 'vue-content-placeholders'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
  position: "top-right",
  timeout: 2000, // ⏱ ตั้งค่า default ทุก toast
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
};

import Toasted from 'vue-toasted'

const api_key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
Vue.use(VueGoogleMaps, {
  load: {
    key: api_key,
    libraries: 'places',
  },
})

Vue.use(Toast, options);
Vue.use(setupCalendar, {})

Vue.use(VueContentPlaceholders)
Vue.use(VueHtmlToPaper, options)
Vue.use(VueHtmlToPaper)
Vue.component('barcode', VueBarcode)
Vue.component('access-data', AccessData)
Vue.component('access-grab',AccessGrab)
Vue.component('loading-page', LoadingPage)
Vue.component('select-shop', SelectShop)
Vue.component('show-date', ShowDate)
Vue.component('modal', Modal)
Vue.use(VueHtml2Canvas)
Vue.config.performance = true
Vue.config.productionTip = false
Vue.use(CoreuiVue)
Vue.use(VCalendar)
Vue.use(VueDatePicker)
// Vue.use(VMdDateRangePicker)
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS,
  router,
})

let app = ''

firebase.auth().onAuthStateChanged(async () => {

  if (app) return

  try {

    if (localStorage.getItem('token')) {
      await store.dispatch('bootstrap')
    }

  } catch (e) {
    console.error('bootstrap error', e)
  }

  app = new Vue({
    router,
    store,
    icons,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')

})
